import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { URLSearchParams } from '@angular/http';  // за удобство при params
import { environment } from '../../environments/environment';

@Injectable()
export class SecurityService {

	private baseUrl = environment.serviceBaseUrl + '/security';

	constructor(private http: HttpService) { }

	private buildUrlWithParams(endpoint: string, params: { [key: string]: any }): string {
		const sp = new URLSearchParams();
		Object.keys(params).forEach(key => {
			if (params[key] !== undefined && params[key] !== null) {
				sp.append(key, params[key]);
			}
		});

		return `${this.baseUrl}/${endpoint}?${sp.toString()}`;
	}

	listUsers() {
		return this.http.get<any[]>(`${this.baseUrl}/listUsers`);
	}

	registerUser(username: string, password: string, names: string, email: string, phone: string, role: string) {
		const url = this.buildUrlWithParams("register", {
			username,
			password,
			names,
			email,
			phoneNumber: phone,
			role
		});

		return this.http.post(url, null);
	}

	changePassword(username: string, password: string) {
		const url = this.buildUrlWithParams("changePassword", { username, password });
		return this.http.post(url, null);
	}

	changeUserAuthority(username: string, role: string) {
		const url = this.buildUrlWithParams("changeUserAuthority", { username, role });
		return this.http.post(url, null);
	}

	changeUserBulinsAuthority(username: string, hasAuthority: boolean) {
		const url = this.buildUrlWithParams("changeUserBulinsAuthority", { username, hasAuthority });
		return this.http.post(url, null);
	}

	unlockUser(username: string) {
		const url = this.buildUrlWithParams("unlockFullyUserAccount", { username });
		return this.http.post(url, null);
	}

	activateUser(username: string, active: boolean) {
		const url = this.buildUrlWithParams("activateUser", { username, active });
		return this.http.post(url, null);
	}

	changeUserNdo(username: string, isNDO: boolean) {
		const url = this.buildUrlWithParams("changeUserNdo", {
			username,
			isNDO
		});
		return this.http.post(url, null);
	}
	impersonate(username: string) {
		const url = this.buildUrlWithParams("impersonate", { username });
		return this.http.post<any>(url, null);
	}

	changeOwnColor(color: string) {
		return this.http.post(`${this.baseUrl}/changeOwnColor`, { color });
	}

	getMyColor() {
		return this.http.get<{ color: string }>(`${this.baseUrl}/myColor`);
	}

	changeColor(username: string, color: string) {
		const url = this.buildUrlWithParams("changeColor", { username, color });
		return this.http.post(url, null);
	}

	changeEmailVerified(username: string, emailVerified: boolean) {
		const url = this.buildUrlWithParams("changeEmailVerified", { username, emailVerified });
		return this.http.post(url, null);
	}

	updateUserFields(username: string, names?: string, email?: string, phone?: string) {
		const url = this.buildUrlWithParams("updateUserFields", {
			username,
			names,
			email,
			phone
		});
		return this.http.post(url, null);
	}

}
